interface BannerUpsellOfferOptions {
  onSubmit: () => void
}

interface BannerUpsellOfferReturn {
  setSubmit: () => void
}

export const useBannerUpsellOffer = ({ onSubmit }: BannerUpsellOfferOptions): BannerUpsellOfferReturn => {
  const setSubmit = (): void => {
    onSubmit()
  }

  return { setSubmit }
}
